import React from 'react';
import VideoStudiosState from './videoStudiosState/VideoStudiosState';
import VideoStudiosControlPanel from './components/VideoStudiosControlPanel/VideoStudiosControlPanel';
import VideoStudios from './components/VideoStudios/VideoStudios';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const VideoStudiosPage: React.FC = () => {
	return (
		<VideoStudiosState>
			<div className={style.container} data-test="VideoStudiosPage">
				<VideoStudiosControlPanel />
				<VideoStudios />
				<ModalWindows />
			</div>
		</VideoStudiosState>
	);
};

export default VideoStudiosPage;
